/**
 * Created by vladislav on 29/03/2023
 */

const PauseControlButton = {
    name: "PauseControlButton",
    buttonType: "control_button",
    icon: bundles.controlbuttons.frames.pause_png,

    onClicked: function () {
        Game.currentGame.pause();

        new PauseWindow();
    },

    isAvailableOnScene: function () {
        return cleverapps.config.type === "battlefield"
            && Game.currentGame && Game.currentGame.mode === Epicart.MODE_BATTLE;
    }
};
